export default "__VITE_ASSET__ZFM4YFbF__"